<template>
    <div class="form-item">
        <label class="label-caption">Tipo Serviço</label>
        <select :value="tipoSelecionado" @change="atualizarTipo" class="form-control" v-bind="$attrs">
            <option v-for="tipo in tiposGrupoServico" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>
  
<script>
export default {
    props: {
        tipoSelecionado: {type: Number, default: null}
    },

    data() {
        return{
            tiposGrupoServico:[
                {id: 1, descricao: 'EQUIPAMENTOS'},
                {id: 2, descricao: 'SERVIÇO/PROFISSIONAIS'}
            ]
        };
    },

    methods: {
        atualizarTipo(event) {
            this.$emit('update:tipoSelecionado', Number(event.target.value));
        }
    }
};
</script>